import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import Cookie from 'js-cookie';
import storage from '@flowio/storage';
import { isNotNil } from '@flowio/is';
import config from './config';
import getCookieDomain from './get-cookie-domain';

function isTemporary(options) {
  return !!(isNotNil(options) && options.useSessionStorage);
}

function setCookie(sess, options, domain) {
  var cookieOptions = {};

  if (domain) {
    cookieOptions.domain = domain;
  }

  if (isTemporary(options)) {
    Cookie.set(config.COOKIE_SESSION_TEMPORARY_KEY, sess.id, cookieOptions);
  } else {
    Cookie.set(config.COOKIE_SESSION_KEY, sess.id, _objectSpread(_objectSpread({}, cookieOptions), {}, {
      expires: config.YEAR_SECONDS
    }));
  }
}

function persistCookie(sess, options) {
  var domain = getCookieDomain();
  setCookie(sess, options, domain); // There is currently an issue with our getCookieDomain code where if the site
  // is on a top level domain with multiple periods like something.co.uk,
  // the domain will actually be set to the TLD which cannot be done so no cookie will be set
  // If a cookie wasn't set when we check, we try to make the cookie
  // again without a domain this time, which will default it to the current full domain

  if (!Cookie.get(config.COOKIE_SESSION_KEY) && !Cookie.get(config.COOKIE_SESSION_TEMPORARY_KEY)) {
    setCookie(sess, options);
  }
}

function persistStorage(sess, options) {
  if (isTemporary(options)) {
    storage.session.set('session', sess);
  } else {
    storage.local.set('session', sess);
  }
}

function persistMemory(sess) {
  storage.memory.set('session', sess);
}

function cleanCookie() {
  Cookie.remove(config.COOKIE_SESSION_KEY);
}
/**
 * Persists session to Storage. Returns if persist was successful or not.
 *
 * @param {Object} sess The full session object from the API.
 * @param {Object} options
 * @param {Object} options.useSessionStorage - store session in session storage / cookie
 * @return {Boolean}     Whether storing the session was successful or not.
 */


function persistSession(sess) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  cleanCookie();
  persistCookie(sess, options);

  try {
    persistStorage(sess, options);
  } catch (error) {
    persistMemory(sess);
  }
}

export default persistSession;
//# sourceMappingURL=persist-session.js.map